export default __webpack_public_path__ + "static/media/welcomeLogo.ff3ce6cf.svg";